/* eslint no-underscore-dangle: ["error", { "allow": ["_clones"] }] */

function stringToBoolean(string, _default) {
  if (string != null && typeof string !== 'undefined') {
    switch (string.toLowerCase().trim()) {
      case 'true':
      case 'yes':
      case '1':
        return true;
      case 'false':
      case 'no':
      case '0':
      default:
        return false;
    }
  } else {
    return _default;
  }
}

function stringToInt(string, _default) {
  if (string != null && typeof string !== 'undefined') {
    return parseInt(string, 10);
  }
  return _default;
}

export default ($elem) => {
  $(() => {
    $elem.find('[data-carousel]').each((index, value) => {
      const $this = $(value);
      const autoplay = stringToBoolean($this.attr('data-auto-play'), false);
      const options = {
        autoplay,
        autoplayHoverPause: stringToBoolean($this.attr('data-hover-pause'), true),
        autoplayTimeout: stringToInt($this.attr('data-timer-delay'), autoplay ? 5000 : 999999),
        mouseDrag: stringToBoolean($this.attr('data-mouse-drag'), false),
        touchDrag: stringToBoolean($this.attr('data-touch-drag'), true),
        pullDrag: stringToBoolean($this.attr('data-pull-drag'), true),
        freeDrag: stringToBoolean($this.attr('data-free-drag'), false),
        center: stringToBoolean($this.attr('data-center'), false),
        margin: stringToInt($this.attr('data-margin'), 0),
        stagePadding: stringToInt($this.attr('data-stage-padding'), 0),
        loop: stringToBoolean($this.attr('data-loop'), true),
        merge: stringToBoolean($this.attr('data-merge'), false),
        mergeFit: stringToBoolean($this.attr('data-merge-fit'), true),
        autoWidth: stringToBoolean($this.attr('data-auto-width'), false),
        nav: stringToBoolean($this.attr('data-nav'), true),
        rewind: stringToBoolean($this.attr('data-rewind'), true),
        dots: stringToBoolean($this.attr('data-dots'), true),
        dotsData: stringToBoolean($this.attr('data-dots-data'), false),
        lazyLoad: stringToBoolean($this.attr('data-lazy-load'), false),
        navText: [
          '<i class="icon icon-chevron-left medium"></i>',
          '<i class="icon icon-chevron-right medium"></i>',
        ],
        smartSpeed: 300,
        items: stringToInt($this.attr('data-items'), 1),
        responsive: {},
        connectedCarousel: $this.attr('data-connected-carousel'),
      };

      if (options.dotsData) {
        options.dotsClass = 'owl-tabs';
        options.dotClass = 'owl-tab';
      }

      if (!stringToBoolean($this.attr('data-animate'), true)) {
        options.smartSpeed = 0;
      }

      if ($this.attr('data-dots-container')) {
        options.dotsContainer = $this.attr('data-dots-container');
      }


      if (typeof window.Foundation.breakpoints === 'object') {
        Object.keys(window.Foundation.breakpoints).forEach((bp) => {
          const items = stringToInt($this.attr(`data-items-${bp}`));
          if (typeof items !== 'undefined') {
            options.responsive[window.Foundation.breakpoints[bp]] = { items };
          }
        });
      }

      $this.owlCarousel(options);

      if (options.connectedCarousel) {
        setTimeout(() => {
          $this.on('changed.owl.carousel', (event) => {
            if (event.property.name === 'position') {
              const connected = $(options.connectedCarousel).data('owl.carousel');
              const other = connected.current() - (connected._clones.length / 2);
              const current = event.property.value - (event.relatedTarget._clones.length / 2);
              if (other !== current) {
                $(options.connectedCarousel).owlCarousel('to', current, 0, true);
                connected.update();
              }
            }
          });
        });
      }
    });
  });
};

